import { render, staticRenderFns } from "./GroupCommentSidebar.vue?vue&type=template&id=249a5a84&"
import script from "./GroupCommentSidebar.vue?vue&type=script&lang=js&"
export * from "./GroupCommentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GroupCommentSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports